/*
 * attachment-type (schema)
 */
import { boolean, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const attachmentTypes = schema.table("attachment_types", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- General ---
	name: varchar("name", { length: 128 }).notNull(),
	description: text("description"),

	// --- PDF Template ---
	pdfTemplateS3Key: varchar("pdf_template_s3_key", { length: 512 }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
